import { setMetierDetailsData, resetMetierDetailsData } from '../../../redux/metierDetailsDataSlice';
import { SuccessfullModifyDialog } from '../../SuccessfullModifyDialog';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { useCallback, useEffect, useState } from 'react';
import MetierDetailsContent from './metierDetailsContent';
import { Box, CircularProgress } from '@mui/material';
import MetierDetailsHeader from './metierDetailsHeader';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import axios from 'axios';

const MetierDetails = () => {

    const { id } = useParams();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);

    const fetchMetierDetails = useCallback(async () => {
        try {
            const { data, status } = await axios.get(`metier/${id}`);
            if ((status === 200 || status === 201) && data) {
                dispatch(setMetierDetailsData(data));
                setLoading(false);
            } else {
                setLoading(false);
                console.warn('Unexpected response status or empty data:', status, data);
            }
        } catch (error) {
            setLoading(false);
            console.error('Erreur lors de la récupération des informations de metier :', error);
            CustomErrorLogger(error, 'Erreur dans fetchMetierDetails');
        }
    }, [id, dispatch]);

    // Scroll to top on mount
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Fetch metier details on mount and cleanup on unmount
    useEffect(() => {
        fetchMetierDetails();
        return () => {
            dispatch(resetMetierDetailsData());
        };
    }, [fetchMetierDetails, dispatch]);

    return (
        <Box>
            {loading ?
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '80vh',
                    }}
                >
                    <CircularProgress
                        sx={{
                            '& .MuiCircularProgress-circle': { stroke: '#EA5E00' },
                        }}
                    />
                </Box>
                :
                <Box>
                    <MetierDetailsHeader />
                    <MetierDetailsContent />
                    <SuccessfullModifyDialog />
                </Box>
            }
        </Box>
    );
}

export default MetierDetails;